import Vue from "vue";
import Buefy from "buefy";
import OrderList from "./App.vue"


Vue.use(Buefy, {
  defaultIconPack: 'fas',
})

Vue.use(OrderList)

if(document.getElementById("orderListApp")){
    new Vue({
        render:h=>h(
            OrderList,{
                props:{
                    listUrl:document.getElementById("orderListApp")
                        .getAttribute("list-url"),
                    detailUrl:document.getElementById("orderListApp")
                        .getAttribute("detail-url")
                }
            }
        )
    }).$mount("#orderListApp")
}

